<template>
  <div
    v-if="disabled"
    :class="[
      'openly-button-anchor',
      'openly-button-anchor--disabled',
      colorClass,
      shapeClass,
    ]"
  >
    <slot />
  </div>
  <NuxtLink
    v-else
    :class="[
      'openly-button-anchor',
      colorClass,
      shapeClass,
    ]"
    tabindex="0"
  >
    <slot />
  </NuxtLink>
</template>

<script setup>

const props = defineProps({
  colorVariant: {
    type: String,
    default: 'primary',
    validator: value => ['primary', 'secondary', 'danger', 'flat', 'plain'].includes(value),
  },
  shapeVariant: {
    type: String,
    default: 'normal',
    validator: value => ['normal', 'round', 'thin'].includes(value),
  },
  disabled: {
    type: Boolean,
    default: false,
  },
})

const colorClass = computed(() => !props.colorVariant ? null : `openly-button-anchor--${props.colorVariant}`)
const shapeClass = computed(() => !props.shapeVariant ? null : `openly-button-anchor--${props.shapeVariant}`)

</script>

<style scoped>
.openly-button-anchor {
  @apply focus:outline-none rounded font-bold transition-colors duration-200 ease-in tracking-wide h-10 whitespace-nowrap border border-transparent inline-flex items-center justify-center text-sm;
}

.openly-button-anchor--primary {
  @apply bg-plum-dark hover:bg-plum-darker active:bg-plum-darkest text-white focus:shadow-outline-plum-light;
}

.openly-button-anchor--secondary {
  @apply border-gray text-gray-darker hover:bg-gray-lightest bg-white active:bg-gray-lighter focus:shadow-outline-gray-light;
}

.openly-button-anchor--secondary.openly-button-anchor--disabled {
  @apply border-transparent;
}

.openly-button-anchor--danger {
  @apply bg-red hover:bg-red-darker active:bg-red-darkest text-white focus:shadow-outline-red-lighter;
}

.openly-button-anchor--flat {
  @apply text-plum-dark hover:bg-plum-lightest active:bg-plum-lighter focus:shadow-outline-plum-light;
}

.openly-button-anchor--plain {
  @apply bg-transparent text-plum-dark hover:text-plum-darker active:text-plum-darkest focus:shadow-outline-plum-light;
}

.openly-button-anchor--normal {
  @apply px-6;
}

.openly-button-anchor--round {
  @apply rounded-full w-10 flex items-center justify-center px-0;
}

.openly-button-anchor--thin {
  @apply px-1 h-auto;
}

.openly-button-anchor--disabled {
  @apply text-gray hover:text-gray active:text-gray cursor-not-allowed;
}

.openly-button-anchor--disabled:not(.openly-button-anchor--plain) {
  @apply bg-gray-light;
}
</style>
